<template>
  <div class="profile__vehicles" @close-modal="closeModal">
    <div class="profile__add-button">
      <a href="#" id="add_vechile" class="btn" @click.prevent="openModal()">
        Agregar
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="512px"
          height="512px"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve"
        >
          <g id="_03_Login_1_">
            <path
              d="M256,512c-13.81,0-25-11.19-25-25V25c0-13.81,11.19-25,25-25c13.81,0,25,11.19,25,25v462C281,500.81,269.81,512,256,512z"
            />
            <path
              d="M487,281H25c-13.81,0-25-11.19-25-25c0-13.81,11.19-25,25-25h462c13.81,0,25,11.19,25,25C512,269.81,500.81,281,487,281z"
            />
          </g>
        </svg>
      </a>
    </div>

    <div class="profile__table__box table-responsive">
      <table
        id="vehicles__table"
        class="profile__table table"
        cellpadding="0"
        cellmargin="0"
        width="100%"
      >
        <thead>
          <tr>
            <th>Placa</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Año</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="element in list" :key="element.id">
            <td class="text-center">{{ element.plate }}</td>
            <td class="text-center">{{ element.brand_name }}</td>
            <td class="text-center">{{ element.vehicle_model_name }}</td>
            <td class="text-center">{{ element.year }}</td>
            <td class="text-right">
              <a
                href="#"
                class="edit"
                @click.prevent="openModal(element.id)"
                data-tooltip="tooltip"
                data-bs-placement="top"
                title="Editar"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="492px"
                  height="491.48px"
                  viewBox="0 0 492 491.48"
                  style="enable-background: new 0 0 492 491.48"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M303.84,82.14L33.13,352.87c-1.36,1.37-2.35,3.09-2.81,4.94L0.31,478.25c-0.9,3.63,0.17,7.48,2.81,10.13 c2,2,4.73,3.11,7.52,3.11c0.85,0,1.73-0.11,2.58-0.32l120.43-30.01c1.88-0.47,3.58-1.45,4.94-2.81l270.73-270.71L303.84,82.14z"
                    />
                    <path
                      d="M476.4,45.23L446.26,15.1c-20.14-20.14-55.24-20.12-75.36,0l-36.91,36.91L439.49,157.5l36.91-36.91 c10.06-10.06,15.6-23.44,15.6-37.68S486.46,55.29,476.4,45.23z"
                    />
                  </g>
                </svg>
              </a>
              <a
                href="#"
                class="delete"
                @click.prevent="deleteElement(element.id)"
                data-tooltip="tooltip"
                data-bs-placement="top"
                title="Eliminar"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="450px"
                  height="512px"
                  viewBox="0 0 450 512"
                  style="enable-background: new 0 0 450 512"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M405,60h-89.18l-9.75-29.24C299.93,12.36,282.77,0,263.38,0h-76.76c-19.4,0-36.55,12.36-42.7,30.76L134.18,60H45 C20.19,60,0,80.19,0,105v30c0,16.71,15.04,15,31.18,15c138.55,0,264.17,0,403.82,0c8.29,0,15-6.71,15-15v-30 C450,80.19,429.81,60,405,60z M165.81,60l6.57-19.75c2.05-6.14,7.78-10.25,14.24-10.25h76.76c6.46,0,12.19,4.12,14.22,10.25 L284.18,60H165.81z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          d="M33.67,182l23.92,289.07C59.71,494.41,78.97,512,102.39,512h245.21c23.42,0,42.69-17.59,44.82-41.06L416.34,182H33.67z M150,437c0,19.77-30,19.85-30,0V227c0-19.77,30-19.85,30,0V437z M240,437c0,19.77-30,19.85-30,0V227c0-19.77,30-19.85,30,0V437z M330,437c0,19.77-30,19.85-30,0V227c0-8.29,6.71-15,15-15c8.29,0,15,6.71,15,15V437z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <profile-vehicle-modal
    :brands="brands"
    :id="vehicleId"
    :url_detail="url_detail"
    :url_store="url_store"
    :url_get_vehicle_models="url_get_vehicle_models"
    :url_get_vehicle_versions="url_get_vehicle_versions"
    @close-modal="closeModal"
    @refresh-table="getList"
  ></profile-vehicle-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { inject, ref } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
  props: {
    brands: {
      type: Array,
      default: () => [],
    },
    vehicle_models: {
      type: Array,
      default: () => [],
    },
    vehicle_versions: {
      type: Array,
      default: () => [],
    },
    years: {
      type: Array,
      default: () => [],
    },
    url_list: {
      type: String,
      default: '',
    },
    url_detail: {
      type: String,
      default: '',
    },
    url_store: {
      type: String,
      default: '',
    },
    url_delete: {
      type: String,
      default: '',
    },
    url_get_vehicle_models: {
      type: String,
      default: '',
    },
    url_get_vehicle_versions: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const loading = inject('loading')

    const list = ref([])
    const vehicleId = ref('')
    const getList = async () => {
      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.url_list,
          method: 'POST',
        })

        list.value = data
      } catch (error) {
        console.error(error)
      }

      loading.value = false
    }
    getList()

    const openModal = (id) => {
      vehicleId.value = id
      $('#addVehicleModal').modal('show')
    }

    const closeModal = () => {
      vehicleId.value = ''
    }

    const deleteElement = async (id) => {
      Swal.fire({
        icon: 'warning',
        title: '¡Ups!',
        text: '¿Está seguro que desea eliminar este registro?',
        showCancelButton: true,
        confirmButtonText: '¡Sí, eliminar!',
        cancelButtonText: '¡No, cancelar!',
      }).then((result) => {
        if (result.value) {
          try {
            axios
              .request({
                url: props.url_delete,
                method: 'POST',
                data: { id: id },
              })
              .then((result) => {
                const { data } = result

                if (data.type === 1) {
                  getList()
                }

                customAlert(data)
              })
          } catch (error) {
            console.error(error)
          }
        }
      })
    }

    return {
      list,
      vehicleId,
      getList,
      openModal,
      closeModal,
      deleteElement,
    }
  },
}
</script>
